import { render, staticRenderFns } from "./Plantio.vue?vue&type=template&id=52c98a5d&scoped=true"
import script from "./Plantio.vue?vue&type=script&lang=js"
export * from "./Plantio.vue?vue&type=script&lang=js"
import style0 from "../../../../css/crud.css?vue&type=style&index=0&id=52c98a5d&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c98a5d",
  null
  
)

export default component.exports